@if (deviceDetail()?.protocol === 'DLMS') {
  <div class="flex justify-end mb-4">
    <button
      type="button"
      mat-stroked-button
      (click)="performOnDemandReadout()"
      [disabled]="isPerformingReadout()"
      class="flex items-center gap-2"
    >
      @if (isPerformingReadout()) {
        <mat-spinner diameter="20"></mat-spinner>
      }
      <span class="font-semibold">
        {{ 'devices.detailTabs.insights.actions.onDemandReadout' | translate }}
      </span>
    </button>
  </div>
}
<xemex-topological-insights-content
  [phaseCountOverride]="deviceDetail()?.phaseCount ?? undefined"
  [meterRole]="meterRole()"
  [telemetryNotShared]="telemetryNotShared()"
></xemex-topological-insights-content>
